import { AppContextType } from '@/contexts/app-context';
import { removeLeadingSlash } from '../utils/strings';

export const humanyFaqQueryCached = async (widgetSlug: string, path = '', baseUrl: string, context: AppContextType) => {
    const sanitizedPath = removeLeadingSlash(path).replace('?', '');
    const viewPath = sanitizedPath.replaceAll(/\//g, '-');
    const internalApiUrl = `api/page/faq/${widgetSlug}-${viewPath || widgetSlug}`;

    let linksClass = 'cached-faq__links';
    if (path.startsWith('/browse')) {
        linksClass += ' browse-archive';
    }

    try {
        const apiResponse = await context?.fetch?.<{ title?: string; content?: string; links?: string }>(internalApiUrl);
        if (apiResponse?.content) {
            return {
                cachedFaq: true,
                statusCode: 200,
                title: apiResponse?.title,
                body: JSON.stringify((apiResponse?.content || '') + '<div class="' + linksClass + '">' + (apiResponse?.links || '') + '</div>'),
            };
        }
    } catch {
        // Don't worry about it
    }

    return {
        cachedFaq: false,
        statusCode: 404,
        body: JSON.stringify('<div>404</div>'),
    };
};
